export default __webpack_public_path__ + "static/media/lgbt.eea79873.svg";